"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./BlockListItems.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _UnboundedCard = require("../UnboundedCard/UnboundedCard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const imageSizes = {
  thumbnail: {
    desktop: {
      width: 272,
      height: 181,
      ratio: {
        width: 3,
        height: 2
      }
    },
    tablet: {
      width: 395,
      height: 254,
      ratio: {
        width: 14,
        height: 9
      }
    },
    mobile: {
      width: 600,
      height: 400,
      ratio: {
        width: 3,
        height: 2
      }
    }
  },
  modal: {
    desktop: {
      width: 1120,
      height: 630,
      ratio: {
        width: 16,
        height: 9
      }
    },
    tablet: {
      width: 840,
      height: 475,
      ratio: {
        width: 168,
        height: 95
      }
    },
    mobile: {
      width: 525,
      height: 296,
      ratio: {
        width: 140,
        height: 79
      }
    }
  }
};
const UnboundedCards = _ref => {
  let {
    content,
    VideoComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  } = _ref;
  const GatsbyImage = content?.GatsbyImage;
  const nestedInTab = content?.tab;
  const {
    theme,
    color,
    backgroundColor
  } = content?.theme || {};
  const renderUnboundedCards = () => {
    if (content?.cards && content?.cards?.length) {
      return content.cards.map((card, index) => {
        const cardContent = {
          locale: card?.locale,
          eyebrow: card?.eyebrow,
          header: card?.header,
          image: card?.image,
          imageSizes: imageSizes,
          displayButton: content?.displayButton,
          cardLink: card?.cardLink,
          text: card?.text,
          GatsbyImage: GatsbyImage,
          Link: content?.Link,
          cardAlignment: content?.cardAlignment,
          buttonSecondary: content?.buttonSecondary,
          modalType: card?.modalType,
          modalContent: card?.modalContent,
          setOverride: card?.setOverride,
          override: card?.override,
          video: card?.video,
          onClick: card?.onClick
        };
        if (cardContent?.cardLink) {
          cardContent.cardLink.external = (0, _checkForExternalLink.default)(cardContent?.cardLink?.url);
        }
        return /*#__PURE__*/_react.default.createElement(_UnboundedCard.UnboundedCard, {
          key: index,
          content: cardContent,
          VideoComponent: VideoComponent ? VideoComponent : null,
          contentfulId: card?.contentfulId ? card?.contentfulId : null
        });
      });
    }
    return null;
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-bounded-cards",
    style: theme === "white" || theme === "concrete-gray" ? {
      background: nestedInTab ? "#fff" : backgroundColor,
      color: color
    } : null
  }, renderUnboundedCards());
};
var _default = UnboundedCards;
exports.default = _default;